<template>
    <el-dialog :title="$t('BusinessPurchaseApplyDetail.dialogText2')" :visible.sync="logVisible" width="500px">
        <el-table :data="logList" border script max-height="600px">
          <el-table-column prop="lastUpdateDate" :label="$t('BjDialogListConfig.Operationtime')" align="center">
            <template slot-scope="scope">
                <template v-if="false" />
                <span v-else>{{ scope.row.lastUpdateDate | timeFilters(scope.row.lastUpdateDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdName" :label="$t('BjDialogListConfig.Operator')" align="center" />
          <el-table-column prop="remarks" :label="$t('BjDialogListConfig.Remarks')" align="center" >
            <template>
                <template v-if="false" />
                <span v-else>Delete file</span>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { userApi } from '@/api';
export default {
    data() {
        return {
            logList: [],
            logVisible: false
        }
    },
    methods:{
        show(){
            this.logVisible = true;
            userApi.getUserfileDetailsList({
                parentId:this.$route.query.parentId-0,
                cusId:this.$route.query.cusId,
                isDelete:1,
                page: 0,
                pageSize: 20,
                size: 20,
                total: 0
            }).then(e=>{
                this.logList = e.content
            })
        },
        handleClose() {
            this.logVisible = false;
        },
        handleConfirm(){
            this.logVisible = false;
        }
    }
}
</script>